var VideoTypes;
(function (VideoTypes) {
    VideoTypes["YOUTUBE"] = "YouTube";
    VideoTypes["VIMEO"] = "Vimeo";
    VideoTypes["LOCAL"] = "Local";
})(VideoTypes || (VideoTypes = {}));

export { VideoTypes };
